import {
    Component,
    ElementRef,
    NgZone,
    ViewChild,
    Inject,
    Optional,
    OnInit,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { RoleService } from "app/main/services/roles.service";
import { TranslateService } from "@ngx-translate/core";
import { COMMA, ENTER } from "@angular/cdk/keycodes";

@Component({
    selector: "representante-dialog-box",
    templateUrl: "./dialog-formulario-box.component.html",
    styleUrls: ["./dialog-formulario-box.component.scss"],
})
export class FormularioDialogBoxComponent {
    action: string;
    LOCAL_DATA: any;
    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    tiposDocumentos = [];
    tiposSujetos = [];
    tiposSectorIndustrial = [];
    tiposProfesiones = [];
    paises = [];

    constructor(
        private roleService: RoleService,
        public dialogRef: MatDialogRef<FormularioDialogBoxComponent>,
        public translate: TranslateService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        console.log(data);
        this.LOCAL_DATA = { ...data };
    }

    doAction(): void {
        this.dialogRef.close({ event: "Delete" });
    }

    closeDialog(): void {
        this.dialogRef.close({ event: "Cancel" });
    }

    openDialog(): void {}
}
